import React, { useState, useEffect } from 'react';
import { Button } from '../base/Button';

export const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-brand-indigo/90 backdrop-blur-md border-b border-brand-teal/20' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <div className="w-8 h-8 mr-3 relative">
              <div className="absolute inset-0 bg-brand-teal/20 rounded-full blur-sm"></div>
              <img 
                src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/86126c0a2c4a8a5efa2a79660917f6e5.png" 
                alt="Whence Logo" 
                className="w-full h-full object-contain relative z-10 drop-shadow-lg filter brightness-110"
                style={{ filter: 'drop-shadow(0 0 8px rgba(29, 211, 176, 0.3))' }}
              />
            </div>
            <h1 className="text-2xl font-bold text-brand-off-white font-pacifico">Whence</h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('vision')}
                className="text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer"
              >
                Vision
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('leap')}
                className="text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer"
              >
                The Leap
              </button>
              <Button
                variant="primary"
                size="sm"
                onClick={() => scrollToSection('contact')}
                className="bg-brand-teal hover:bg-brand-teal/80"
              >
                Join Us
              </Button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-brand-off-white p-2 cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-brand-indigo/95 backdrop-blur-md border-t border-brand-teal/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => scrollToSection('vision')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer w-full text-left"
              >
                Vision
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer w-full text-left"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('leap')}
                className="block px-3 py-2 text-gray-300 hover:text-brand-teal transition-colors duration-200 cursor-pointer w-full text-left"
              >
                The Leap
              </button>
              <div className="px-3 py-2">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-brand-teal hover:bg-brand-teal/80"
                >
                  Join Us
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
